import React from 'react'
import Link from 'next/link'
import { Button } from 'antd'
import { useTranslation } from 'next-i18next'
import { ArrowLeftOutlined } from '@ant-design/icons'

interface GoBackLinkProps {
  link: string
  label?: string
}

const GoBackLink: React.FC<GoBackLinkProps> = (props) => {
  const { t } = useTranslation()
  const { link, label = t('general.GoBackToList') } = props

  const button = <Button type='text' icon={<ArrowLeftOutlined />}>
    {label}
  </Button>

  return <Link href={link} legacyBehavior><a>{button}</a></Link>
}

export default GoBackLink
